import { render, staticRenderFns } from "./host-common-region.vue?vue&type=template&id=596e9a4c&scoped=true&"
import script from "./host-common-region.vue?vue&type=script&lang=js&"
export * from "./host-common-region.vue?vue&type=script&lang=js&"
import style0 from "./host-common-region.vue?vue&type=style&index=0&id=596e9a4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596e9a4c",
  null
  
)

export default component.exports